import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@/lib/api-client";
import type {
  CompanyData,
  DashboardResponse,
  UpdateCompanyRequest,
  UpdateContactsRequest,
} from "@/types/api";
import { DASHBOARD_QUERY_KEY } from "./use-dashboard";

function useUpdateAccount<TPayload>(path: string) {
  const queryClient = useQueryClient();
  return useMutation<CompanyData, Error, TPayload>({
    mutationFn: (payload) => apiClient.patch<CompanyData>(path, payload),
    onSuccess: (updated) => {
      queryClient.setQueryData<DashboardResponse>(DASHBOARD_QUERY_KEY, (prev) =>
        prev ? { ...prev, companyData: updated } : prev,
      );
    },
  });
}

export const useUpdateCompany = () => useUpdateAccount<UpdateCompanyRequest>("/account/company");
export const useUpdateContacts = () => useUpdateAccount<UpdateContactsRequest>("/account/contacts");
